import React, { useState } from "react";

import { Calendar } from "react-date-range";
import { addDays, format, isWeekend, addYears } from "date-fns";
import "../styles/dateRangePicker.scss";

export default function DateRangePicker({
  onChangeDate,
  minDate,
  maxDate,
  hideDatePicker,
  date,
}) {
  const [state, setState] = useState(null);

  function customDayContent(day) {
    var extraDot = null;
    if (isWeekend(day)) {
      extraDot = (
        <div
          style={{
            height: "5px",
            width: "5px",
            borderRadius: "100%",
            background: "#e91e63",
            position: "absolute",
            top: 2,
            right: 2,
          }}
        />
      );
    }
    return (
      <div>
        <span>{format(day, "d")}</span>
      </div>
    );
  }

  return (
    <div className="date-range-picker-container">
      <Calendar
        onChange={(item) => {
          // console.log(item);
          setState(item);
          onChangeDate(item);
        }}
        showMonthAndYearPickers={true}
        // date={date === "" ? null : new Date(date)}
        color={"#e31c74"}
        dayContentRenderer={customDayContent}
        minDate={minDate ? new Date(minDate) : new Date()}
        maxDate={maxDate ? new Date(maxDate) : addYears(new Date(), 1)}
      />
    </div>
  );
}
